
import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { handleImageError } from '@/utils/imageHandling';

interface NavbarLogoProps {
  isScrolled: boolean;
}

const NavbarLogo: React.FC<NavbarLogoProps> = ({ isScrolled }) => {
  return (
    <Link to="/" className="flex items-center group" aria-label="Cats About Town Tours - Home">
      <img 
        src="/lovable-uploads/a7814c71-1569-43b8-8a9c-e24f811be427.png" 
        alt="Cats About Town Tours Logo" 
        className={cn(
          "transition-transform duration-300 object-contain",
          isScrolled ? "h-12 w-auto" : "h-14 w-auto"
        )}
        width="auto"
        height={isScrolled ? "48" : "56"}
        loading="eager"
        onError={(e) => handleImageError(e)}
      />
      <span className="text-xl font-montserrat font-bold hidden sm:block ml-3">
        <span className="text-[#8D6E63]">Cats</span>
        <span className="text-[#3E2723]"> About Town Tours</span>
      </span>
    </Link>
  );
};

export default NavbarLogo;
